import { FormInstance } from "antd/es/form";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IStockCountHeader_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStockCountHeader_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetOfficeList: any[];
  GetOfficeList_dummy: any[];
  GetOfficeWarehouseList: any[];
  GetOfficeWarehouseList_dummy: any[];
  HS_InventoryCountInsert: any[];
  HS_InventoryCountInsert_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  WriteToLocalStorage: any;
  WriteToLocalStorage_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  isComp674698Visible: "visible" | "hidden";
  isComp497198Enabled: "enabled" | "disabled";
}

export class StockCountHeader_ScreenBase extends React.PureComponent<
  IStockCountHeader_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  stockcountheader_803595_value_kuikaSelectBoxRef: React.RefObject<any>;
  stockcountheader_653547_value_kuikaSelectBoxRef: React.RefObject<any>;
  stockcountheader_497198_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "336f0017-bcef-485b-b6a6-34fc540cd83b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 588591, PropertyName: "value", Value: "Sayım Oluştur" },
        { Id: 690454, PropertyName: "value", Value: "Ofis Adı" },
        { Id: 803595, PropertyName: "placeholder", Value: "Ofis Seçiniz" },
        { Id: 635712, PropertyName: "value", Value: "Depo Adı" },
        { Id: 653547, PropertyName: "placeholder", Value: "Depo Seçiniz" },
        { Id: 7671, PropertyName: "value", Value: "İşlem Tarihi" },
        {
          Id: 497198,
          PropertyName: "placeholder",
          Value: "İşlem Tarihi Seçiniz",
        },
        { Id: 288, PropertyName: "value", Value: "Açıklama" },
        { Id: 414152, PropertyName: "placeholder", Value: "Açıklama Giriniz" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.stockcountheader_803595_value_kuikaSelectBoxRef = React.createRef();
    this.stockcountheader_653547_value_kuikaSelectBoxRef = React.createRef();
    this.stockcountheader_497198_value_kuikaDatetimeRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetOfficeList: [],
      GetOfficeWarehouseList: [],
      HS_InventoryCountInsert: [],
      Notify: false,
      WriteToLocalStorage: "",
      NAVIGATE: "",
      isComp674698Visible: "hidden",
      isComp497198Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "stockcountheader",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.StockCountHeaderPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.StockCountHeaderPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "stockcountheader",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "stockcountheader",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StockCountHeaderPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.StockCountHeaderPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stockcountheader_497198_value: moment().format("YYYY-MM-DDTHH:mm:ss"),
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  StockCountHeaderPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountHeader/StockCountHeaderPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOfficeList = result?.data.getOfficeList;

    formVars.stockcountheader_803595_options = stateVars.GetOfficeList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountHeaderPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountHeaderPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_803595 =
      stateVars.GetOfficeList ?? this.state.GetOfficeList;
    stateVars.dataSource_803595 =
      stateVars.GetOfficeList ?? this.state.GetOfficeList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StockCountHeaderComponent_55183_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountHeaderComponent_803595_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      officeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_803595_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeCode"
          )
        ),
        "string"
      ),
      warehouseCode_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountHeader/StockCountHeaderComponent_803595_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOfficeWarehouseList = result?.data.getOfficeWarehouseList;

    formVars.stockcountheader_653547_options = stateVars.GetOfficeWarehouseList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountHeaderComponent_803595_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountHeaderComponent_803595_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_653547 =
      stateVars.GetOfficeWarehouseList ?? this.state.GetOfficeWarehouseList;
    stateVars.dataSource_653547 =
      stateVars.GetOfficeWarehouseList ?? this.state.GetOfficeWarehouseList;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountHeaderComponent_656886_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CreatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      ERPDocumentNo_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      InventoryCountDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_414152_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OfficeCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_803595_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeCode"
          )
        ),
        "string"
      ),
      OfficeCodeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_803595_value",
            "value",
            "GetOfficeList",
            "officeCode",
            "officeDescription"
          )
        ),
        "string"
      ),
      StoreCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_653547_value",
            "value",
            "GetOfficeWarehouseList",
            "warehouseCode",
            "storeCode"
          )
        ),
        "string"
      ),
      StoreCodeDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_653547_value",
            "value",
            "GetOfficeWarehouseList",
            "warehouseCode",
            "storeDescription"
          )
        ),
        "string"
      ),
      WarehouseCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_653547_value",
            "value",
            "GetOfficeWarehouseList",
            "warehouseCode",
            "warehouseCode"
          )
        ),
        "string"
      ),
      WarehouseDescription_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountheader_653547_value",
            "value",
            "GetOfficeWarehouseList",
            "warehouseCode",
            "warehouseDescription"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountHeader/StockCountHeaderComponent_656886_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_InventoryCountInsert = result?.data.hS_InventoryCountInsert;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountHeaderComponent_656886_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountHeaderComponent_656886_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_InventoryCountInsert !== undefined
          ? stateVars.HS_InventoryCountInsert?.length > 0
            ? stateVars.HS_InventoryCountInsert[0].message
            : null
          : this.state.HS_InventoryCountInsert?.length > 0
          ? this.state.HS_InventoryCountInsert[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      3,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountHeaderComponent_656886_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountHeaderComponent_656886_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_InventoryCountInsert !== undefined
            ? stateVars.HS_InventoryCountInsert?.length > 0
              ? stateVars.HS_InventoryCountInsert[0].success
              : null
            : this.state.HS_InventoryCountInsert?.length > 0
            ? this.state.HS_InventoryCountInsert[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.WriteToLocalStorage =
        await ReactSystemFunctions.writeToLocalStorage(
          ReactSystemFunctions.convertToTypeByName("CountHeaderId", "string"),
          ReactSystemFunctions.toString(
            this,
            stateVars.HS_InventoryCountInsert !== undefined
              ? stateVars.HS_InventoryCountInsert?.length > 0
                ? stateVars.HS_InventoryCountInsert[0].id
                : null
              : this.state.HS_InventoryCountInsert?.length > 0
              ? this.state.HS_InventoryCountInsert[0].id
              : null
          )
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountHeaderComponent_656886_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountHeaderComponent_656886_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  StockCountHeaderComponent_656886_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_InventoryCountInsert !== undefined
            ? stateVars.HS_InventoryCountInsert?.length > 0
              ? stateVars.HS_InventoryCountInsert[0].success
              : null
            : this.state.HS_InventoryCountInsert?.length > 0
            ? this.state.HS_InventoryCountInsert[0].success
            : null
        ),
        true
      )
    ) {
      const __currentPath = (
        window.location.hash
          ? window.location.hash.replace(/^#/, "").split("?")[0]
          : window.location.pathname.split("?")[0]
      ).toLowerCase();
      if (__currentPath !== "/stockcountdetail") {
        this.context.setMasterPageInitLoaded(false);
        this.context.setMasterPageRecurringLoaded(false);
        this.context.setShouldTriggerPageInit(true);
      }
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "StockCountDetail",
        "StockCountHeaderId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            stateVars.HS_InventoryCountInsert !== undefined
              ? stateVars.HS_InventoryCountInsert?.length > 0
                ? stateVars.HS_InventoryCountInsert[0].id
                : null
              : this.state.HS_InventoryCountInsert?.length > 0
              ? this.state.HS_InventoryCountInsert[0].id
              : null
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "StockCountHeader",
        "StockCountDetail",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.StockCountHeaderPageInit();
    }
  }
}
